import { useState, useMemo } from "react"
import { useLocation } from "react-router"
import { postSendRequestToken } from "../../myApiCenter"
import toast from "react-hot-toast"
import { useContext } from "react"
import { AuthContext } from "../../context/Can"
import { Input } from "reactstrap"

const parseTokenFromText = (text) => {
   try {
      const cleaned = text.trim()
      if (!cleaned) return null

      let paramString = ""

      // Case 1: Full URL present
      const urlMatch = cleaned.match(/https?:\/\/[^\s]+/)
      if (urlMatch) {
         const questionMarkIndex = urlMatch[0].indexOf("?")
         if (questionMarkIndex !== -1) {
            paramString = urlMatch[0].substring(questionMarkIndex + 1)
         }
      }

      // Case 2: Raw query params like request_token=xxx&action=login&status=success
      if (!paramString) {
         const paramMatch = cleaned.match(/request_token=[^\s]+/)
         if (paramMatch) {
            paramString = paramMatch[0]
         }
      }

      if (!paramString) return null

      const params = new URLSearchParams(paramString)
      const requestToken = params.get("request_token")
      const status = params.get("status")

      if (status && status !== "success") {
         return { error: `Kite login failed with status: ${status}. Please try again.` }
      }

      if (!requestToken) return { error: "request_token not found in pasted text." }

      return { requestToken }
   } catch {
      return { error: "Could not parse the pasted text. Please paste the full redirect URL." }
   }
}

const LogInWithKite = () => {
   const [userData] = useContext(AuthContext)
   const location = useLocation()
   const query = new URLSearchParams(location.search)

   // Kite redirects back with request_token in URL
   const requestTokenFromUrl = query.get("request_token")
   const statusFromUrl = query.get("status")

   const [apiKey, setApiKey] = useState(userData?.brokerDetail?.apiKey || "")
   const [manualUrl, setManualUrl] = useState("")

   const parsedResult = useMemo(() => parseTokenFromText(manualUrl), [manualUrl])

   // URL params take priority
   const urlTokens = requestTokenFromUrl && statusFromUrl === "success"
      ? { requestToken: requestTokenFromUrl }
      : null

   const finalTokens = urlTokens || (parsedResult && !parsedResult.error ? parsedResult : null)

   const submitHandler = async () => {
      if (!finalTokens) {
         toast.error("No valid request_token found")
         return
      }
      try {
         // backend will exchange request_token → access_token and save it
         await postSendRequestToken(finalTokens)
         toast.success("Token saved successfully")
      } catch (error) {
         console.log(error)
         toast.error("Failed to save token")
      }
   }

   return (
      <div className="login-with-kite-wrap">
         <h1>Jay Mat Bhavani</h1>

         <div className="redirect-home w-50">
            <Input
               value={apiKey}
               onChange={(e) => setApiKey(e.target.value)}
               placeholder="Enter API Key"
            />
            <button
               onClick={() => {
                  if (apiKey) {
                     // Kite OAuth redirect — your app's redirect_uri must be registered in Kite developer console
                     window.location.replace(
                        `https://kite.trade/connect/login?api_key=${apiKey}&v=3`
                     )
                  } else {
                     toast.error("API key field should not be empty")
                  }
               }}
               className="my-kite-btn"
            >
               Redirect To Kite
            </button>
         </div>

         <div className="manual-token-wrap w-50 mt-2">
            <p className="mb-1">If not redirected automatically, paste the full redirect URL below:</p>
            <Input
               type="textarea"
               rows={5}
               value={manualUrl}
               onChange={(e) => setManualUrl(e.target.value)}
               placeholder="Paste the full redirect URL containing request_token here..."
            />
            {manualUrl && parsedResult?.error && (
               <p style={{ color: "red", marginTop: 4, fontSize: 14 }}>{parsedResult.error}</p>
            )}
            {manualUrl && parsedResult && !parsedResult.error && (
               <p style={{ color: "green", marginTop: 4 }}>request_token parsed successfully</p>
            )}
         </div>

         {finalTokens && (
            <button type="button" onClick={submitHandler} className="my-kite-btn mt-1">
               Save Token
            </button>
         )}
      </div>
   )
}

export default LogInWithKite